import React from "react";
import { Link } from "react-router-dom";

const Download = () => {
  return (
    <section className="download_sec" id="download_sec">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-md-6 mt-4 mt-md-0 order-md-1 order-2">
            <div className="download_content">
              <h6 className="black mb-md-5 mb-4 text-center">
                Advance Your{" "}
                <img
                  src="./assets/imges/ai-txt.svg"
                  alt="ai"
                  className="Ai-txt"
                />{" "}
                Journey Download The App
              </h6>
              <div className="text-center download-icon">
                <Link to={process.env.REACT_APP_ANDROID_APP_LINK} className="me-4" target="_blank">
                  <img src="./assets/imges/play_store.svg" alt="google-store" />
                </Link>
                <Link to={process.env.REACT_APP_IOS_APP_LINK} target="_blank">
                  <img
                    src="./assets/imges/google_store.svg"
                    alt="google-store"
                  />
                </Link>
              </div>
            </div>
          </div>
          <div className="col-md-6 text-lg-end order-md-2 order-1">
            <img
              src="./assets/imges/download.png"
              alt="download"
              className="img-fluid"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Download;
